import { render } from "./Group9.vue?vue&type=template&id=5b166a0a&scoped=true"
import script from "./Group9.vue?vue&type=script&lang=js"
export * from "./Group9.vue?vue&type=script&lang=js"

import "./Group9.vue?vue&type=style&index=0&id=5b166a0a&lang=css"
import "./Group9.vue?vue&type=style&index=1&id=5b166a0a&scoped=true&lang=css"

import exportComponent from "D:\\wcb\\www\\wifigolf\\s_api\\public\\ClpgaApp121\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b166a0a"]])

export default __exports__